import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { backendClient } from './backendClient'

const backendRequest = async <T>(options: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse<T>) => {
    const { data } = response
    return data
  }

  const onError = (error: AxiosError) => {
    return Promise.reject(error)
  }

  return backendClient(options).then(onSuccess).catch(onError)
}

export const backendRequestWithStatus = async <T>(options: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse<T>) => ({
    data: response.data,
    status: response.status
  })

  const onError = (error: AxiosError) => Promise.reject(error)

  return backendClient(options).then(onSuccess).catch(onError)
}

export default backendRequest
